import type { ComponentProps, ReactNode } from 'react';
import clsx from 'clsx';

interface Props extends ComponentProps<'span'> {
  text?: string;
  className?: string;
  children?: ReactNode;
}

const MutedText = ({ text = '', className, children = null, ...props }: Props) => {
  return (
    <span {...props} className={clsx('text-sm font-normal text-gray-500', className)}>
      {text}
      {children ? children : null}
    </span>
  );
};

export default MutedText;
